





import { defineComponent } from '@vue/composition-api';
import { SidebarPlacement } from '../types/sidebar-placement';

export default defineComponent({
  name: 'SidebarInnerWrapper',
  props: {
    placement: {
      type: String,
      default: SidebarPlacement.Left,
    },
  },
});
